/*
 * @Author: wzh
 * @LastEditTime: 2023-05-09 11:12:14
 * @Description: 工具函数
 */

/**
 * 例子:
 * export const abslyByArr = arr => arr.map(value => Math.abs(value))
 */

// token 格式化
export function authorizationFormat(token) {
  return `Bearer ${token}`;
}

/**
 * @description: 判断PC端、移动端;
 */
export function isMobile() {
  let userAgent = navigator.userAgent;
  let flag = userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  // console.log(userAgent, flag);
  return flag;
}

/**
 * @description: 获取当前语言
 * @param {*} isLabel true 返回对象，false 返回value
 */
export function currentLanguage(isLabel = false) {
  let str = localStorage.getItem("language");
  let obj = str ? JSON.parse(str) : { value: "zh", text: "简体中文" };
  return isLabel ? obj : obj.value;
}

// 获取url参数是否包含redirect_uri, 用于区分根路由重定向地址
export function redirectUriParams() {
  let obj = {};
  let url = window.location.href;
  let params = url.split("?")[1] || "";
  let arr = params.split("&");
  if (arr.length) {
    arr.forEach((el) => {
      if (el) {
        obj[el.split("=")[0]] = el.split("=")[1];
      }
    });
  }
  return obj;
}
